// A anotação antes de ir para o `lerMarkdown` — comum à tela e ao PDF.
//
// Anotação digitada à mão, sem marcação, tem a quebra de linha como único
// sinal de "outro assunto". O Markdown emenda linhas seguidas num parágrafo
// só; aqui, cada linha quebrada vira parágrafo próprio — menos dentro de
// listas, citações, títulos e tabelas, onde a quebra já tem sentido.
const MARCADOR = /^\s{0,3}([-*+•>]|\d{1,3}[.)])\s|^\s{0,3}#{1,6}\s|^\s*\|/;

export function prepararNota(texto: string): string {
  const linhas = texto.replace(/\r\n?/g, '\n').split('\n');
  const saida: string[] = [];
  linhas.forEach((l, i) => {
    saida.push(l);
    const prox = linhas[i + 1];
    if (prox !== undefined && l.trim() && prox.trim() && !MARCADOR.test(l) && !MARCADOR.test(prox)) saida.push('');
  });
  return saida.join('\n');
}
